import { domainCode } from '../../constants/staticPageConstants';
import { setQueryParamToLink } from '../Header/utils';
import { NAV_TYPES } from '../cms/layout/components/header';
import {
  BOOK_DEMO_TEXT,
  CONTACT_US_TEXT,
  REQUEST_DEMO_TEXT,
} from './constants';

export function setCMSPageQueryParams(
  refValue: string,
  pathName: string | string[],
  btnLink: string,
  type: number
): string {
  if (btnLink !== '#') {
    btnLink = setQueryParamToLink(btnLink, 'utm_ref', refValue);

    if (type === NAV_TYPES.B2B && typeof pathName === 'string') {
      btnLink = setQueryParamToLink(btnLink, 'ref', pathName);
    }
  }

  return btnLink;
}

export const demoText = (domain: number): string => {
  if (domain === domainCode.cleartaxIn) {
    return REQUEST_DEMO_TEXT;
  } else if (domain === domainCode.ClearTech) {
    return CONTACT_US_TEXT;
  } else {
    return BOOK_DEMO_TEXT;
  }
};

export const showBookDemoPopUp = (domain: number): boolean => {
  const domainList = [
    domainCode.cleartaxAE,
    domainCode.cleartaxBH,
    domainCode.cleartaxES,
    domainCode.cleartaxFR,
    domainCode.cleartaxMY,
    domainCode.cleartaxOM,
    domainCode.cleartaxPL,
    domainCode.cleartaxSA,
  ];

  return domainList.includes(domain);
};

export const REQUEST_DEMO_LINK = (domain: number): string => {
  switch (domain) {
    case domainCode.cleartaxIn:
      return 'https://cleartax.in/s/contact-sales';
    case domainCode.ClearTech:
      return 'https://www.clear.tech/contact-us';
    case domainCode.cleartaxSA:
    case domainCode.cleartaxOM:
    case domainCode.cleartaxBH:
    case domainCode.cleartaxAE:
    case domainCode.cleartaxFR:
    case domainCode.cleartaxES:
    case domainCode.cleartaxPL:
    case domainCode.cleartaxMY:
      return '#';

    default:
      return 'https://cleartax.in/s/contact-sales';
  }
};
